module.exports = __webpack_public_path__ + "static/media/magazineTupp_03_thumb_hover.afcd54ce.png";